<template>
  <div class="mobile-nav-wrapper d-lg-none">
    <div class="mobile-nav-bar" :class="{ 'scrollable': menuArray.length > 4 }">
      <div class="mobile-nav-scroll">
        <div 
          v-for="item in menuArray"
          :key="item.title"
          class="mobile-nav-item"
          :class="{ 'active': isActive(item) }"
          @click="navigateTo(item)"
        >
          <v-icon class="nav-icon">{{ item.icon }}</v-icon>
          <span class="nav-text">{{ item.title }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DataService from '../../../_services/DataService';
export default {
  data() {
    return {
      permission: '',
      menuArray: [],
      patient: [
        {
          icon: 'mdi-monitor-dashboard',
          title: 'Dashboard',
          link: '/dashboard',
        },
        {
          icon: 'mdi-calendar-month',
          title: 'Schedule',
          link: '/scheduled_appointments',
        },
        {
          icon: 'mdi-account-circle-outline',
          title: 'Account',
          link: '/account',
        },
        {
          title: 'Logout',
          click: 'onLogout',
          icon: 'mdi-logout',
          active: 1,
        },
      ],
      clientAdmin: [
        {
          icon: 'mdi-monitor-dashboard',
          title: 'Dashboard',
          link: '/dashboard',
        },
        {
          icon: 'mdi-email',
          title: 'Messaging',
          link: '/messaging',
        },
        {
          icon: 'mdi-shield-account-outline',
          title: 'Admin',
          link: '/admin',
        },
        {
          icon: 'mdi-chart-line',
          title: 'reporting',
          link: '/reporting',
        },
        {
          icon: 'mdi-account-circle-outline',
          title: 'Account',
          link: '/account',
        },
        {
          title: 'Logout',
          click: 'onLogout',
          icon: 'mdi-logout',
          active: 1,
        },
      ],
    };
  },
  mounted(){
    switch (DataService.getRole()) {
    case 'clientAdmin':
      this.menuArray = this.clientAdmin;
      break;
    case 'patient':
      this.menuArray = this.patient;
      break;
    default:
      this.menuArray = [];
    }
  },
  methods: {
    navigateTo(route) {
      route.link ? this.$router.push(route.link) : this.onLogout();
    },
    onLogout() {
      this.$root.$emit('logout');
      DataService.logout();
    },
    isActive(item) {
      // Handle special case for schedule routes
      if (item.link === '/scheduled_appointments' && (this.$route.path === '/scheduled_appointments' || this.$route.path === '/patient_schedule')) {
        return true;
      }
      if (item.link === '/reporting' && this.$route.path === '/reporting') {
        return true;
      }
      return this.$route.path === item.link;
    },
  },
  
};
</script>
<style lang="scss" scoped>
@import '@/scss/variables.scss';

// Component-specific colors
$mobile-nav-bg-primary: #133b54;
$mobile-nav-bg-secondary: #1a365d;
$mobile-nav-shadow: rgba(0, 0, 0, 0.15);
$mobile-nav-text: rgba(255, 255, 255, 0.8);
$mobile-nav-icon: white;
$mobile-nav-hover-bg: rgba(255, 255, 255, 0.1);
$mobile-nav-active-bg: #b0d35e;
$mobile-nav-active-text: #414a5b;

.mobile-nav-wrapper {
  position: fixed;
  bottom: -1px;
  left: 0;
  right: 0;
  z-index: 1000;
  margin: 0;
  padding: 0;
  border: none;
}

.mobile-nav-bar {
  display: flex;
  background: linear-gradient(180deg, $mobile-nav-bg-primary 0%, $mobile-nav-bg-secondary 100%);
  box-shadow: 0 -4px 12px $mobile-nav-shadow;
  padding: 0;
  height: $mobile-nav-height;
  position: relative;
  border: none;
  
  &.scrollable {
    overflow: hidden;
    
    &::before,
    &::after {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      width: 20px;
      pointer-events: none;
      z-index: 1;
    }
    
    &::before {
      left: 0;
      background: linear-gradient(to right, $mobile-nav-bg-secondary, transparent);
    }
    
    &::after {
      right: 0;
      background: linear-gradient(to left, $mobile-nav-bg-secondary, transparent);
    }
    
    .mobile-nav-scroll {
      overflow-x: auto;
    }
    
    .mobile-nav-item {
      flex: 0 0 auto;
      min-width: 85px;
      padding: 0 8px;
    }
  }
  
  .mobile-nav-scroll {
    display: flex;
    overflow-x: hidden;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    width: 100%;
    
    &::-webkit-scrollbar {
      display: none;
    }
  }
  
  .mobile-nav-item {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background-color $transition-fast ease;
    color: $mobile-nav-text;
    height: 100%;
    
    &:hover {
      background-color: $mobile-nav-hover-bg;
    }
    
    &.active {
      background-color: $mobile-nav-active-bg;
      
      .nav-icon,
      .nav-text {
        color: $mobile-nav-active-text;
      }
    }
    
    .nav-icon {
      font-size: 22px !important;
      margin-bottom: 6px;
      color: $mobile-nav-icon;
    }
    
    .nav-text {
      font-size: 11px;
      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: 0.3px;
      line-height: 1.1;
      text-align: center;
      white-space: nowrap;
    }
  }
}
</style>
